// Buyer-facing wording for OrderSummary.status. The stored values are
// unchanged; `draft` is the intake state a new order lands in, which reads
// as "Placed" to the buyer who just made it (#170).
const BUYER_ORDER_STATUS_LABELS = {
	draft: 'Placed',
	processing: 'Processing',
	shipped: 'Shipped',
	delivered: 'Delivered',
	cancelled: 'Cancelled',
};

export const formatBuyerOrderStatus = (status) =>
	BUYER_ORDER_STATUS_LABELS[String(status || '').toLowerCase()] || status || '—';
